module.exports = __webpack_public_path__ + "img/rgzn_s.193ec1f.png";